import { RegisterOptions } from 'react-hook-form'

export const toMillimeter = (meter = 0) => (meter > 0 ? meter * 1000 : 0)

export const makeFormRules = (rules: Partial<RegisterOptions> = {}): RegisterOptions => ({
  min: 0,
  required: true,
  ...rules,
})
